import {createMuiTheme} from '@material-ui/core/styles';

const theme = createMuiTheme({
    palette: {
        primary: {
          main: '#263238',
        },
        secondary: {
          main: '#8d6e63',
        },
      },
})

export default theme